<script setup lang="ts">
import ArticlePublicPage from '~/components/Article/ArticlePublicPage.vue';
import { IaPageAudience } from '~/composables/unified/useIaAudience';

// An article with no consideration area is served here. ArticlePublicPage looks the article up by
// slug and redirects to its canonical URL when it has one under an area.
definePageMeta({
  authType: [AUTH_ROUTE_TYPE_NONE],
  name: 'articles-slug',
  layout: 'unified-public',
  // A signed-in student under the new information architecture reads it inside the coach shell.
  ia: { audience: IaPageAudience.All, on: '/coach/articles/:articleSlug', fullWidth: true },
  iaBack: true,
});
</script>

<template>
  <ArticlePublicPage />
</template>
